import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

export default function ModalQuestion(props) {
	const onNoClick = () => {
		props.toggle();
		props.onNoClick();
	}

	const onYesClick = () => {
		props.toggle();
		props.onYesClick();
	}

	return (
		<Modal isOpen={props.isOpen} toggle={props.toggle}>
			<ModalHeader>{props.title}</ModalHeader>
			<ModalBody>
				<div className="row">
					<div className="form-group col-sm-12">
						<span>
							<strong>{props.question}</strong>
						</span>
					</div>
				</div>
			</ModalBody>
			<ModalFooter>
				<Button color="danger" onClick={() => onNoClick()}>
					{props.noText ? props.noText : "No"}
				</Button>
				<Button color="primary" onClick={() => onYesClick()}>
					{props.yesText ? props.yesText : "Yes"}
				</Button>
			</ModalFooter>
		</Modal>
	);
}



// WEBPACK FOOTER //
// ./src/App/component/ModalQuestion.js